import { Blip } from '.';

export function generateSeed(ringName: string, sectionName: string, blipName: string) {
  const sumRing = ringName.split('').reduce(function (p, c) {
    return p + c.charCodeAt(0);
  }, 0);
  const sumSection = sectionName.split('').reduce(function (p, c) {
    return p + c.charCodeAt(0);
  }, 0);
  const sumBlip = blipName.split('').reduce(function (p, c) {
    return p + c.charCodeAt(0);
  }, 0);
  return Math.PI * sumRing * ringName.length * sumSection * sectionName.length * sumBlip * blipName.length;
}

export function isColliding(blip: Blip, existingCoords: { x: number; y: number }[]) {
  return existingCoords.some(function (coord) {
    return Math.abs(coord.x - blip.x) < blip.width && Math.abs(coord.y - blip.y) < blip.width;
  });
}

// https://stackoverflow.com/a/41491220
export function pickTextColorBasedOnBackgroundColor(bgColor: string, lightColor: string, darkColor: string) {
  var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
  var r = parseInt(color.substring(0, 2), 16); // hexToR
  var g = parseInt(color.substring(2, 4), 16); // hexToG
  var b = parseInt(color.substring(4, 6), 16); // hexToB
  return r * 0.299 + g * 0.587 + b * 0.114 > 150 ? darkColor : lightColor;
}

export const groupBy = (array: any[], key: string): { [key: string]: Blip[] } => {
  // Return the end result
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};

export function getClassSafeName(text: string) {
  return text.replace(/[^a-z0-9+]+/gi, '-');
}
